import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { 
    getPCORMeasureDataRequest, 
    getPCORMeasureDataSuccess, 
    getPCORMeasureDataError, 
    setPCORMeasureLoading,
    getPCORFilterSuccess,
    getPCORFilterError,
    setPCORFilterLoading
} from '@src/middleware/actions/PCOR/pcorActions';
import { getPcorQualityMeasureData, getPcorFilterTinData } from '@src/middleware/services/pcor/pcor.service';
import { PCOR_DATA_REQUEST, PCOR_FILTER_REQUEST } from '../actions/actionTypes';


export function* getPCORMeasureData(action: any) {
    try {
        yield put(setPCORMeasureLoading(true));
        const response = yield call(
            getPcorQualityMeasureData,
            action?.payload
        );
        yield put(getPCORMeasureDataSuccess(response));
        yield put(setPCORMeasureLoading(false));
    } catch (error) {
        yield put(getPCORMeasureDataError(error));
        yield put(setPCORMeasureLoading(false));
    }
}

export function* getPCORFilterData(action: any) {
    try {
        yield put(setPCORFilterLoading(true));
        const response = yield call(
            getPcorFilterTinData,
            action?.payload
        );
        yield put(getPCORFilterSuccess(response));
        yield put(setPCORFilterLoading(false));
    } catch (error) {
        yield put(getPCORFilterError(error));
        yield put(setPCORFilterLoading(false));
    }
}

export function* pcorSaga() {
    yield takeLatest(PCOR_DATA_REQUEST, getPCORMeasureData);
    yield takeLatest(PCOR_FILTER_REQUEST, getPCORFilterData);
}

export default pcorSaga;